var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player",style:('width:' + _vm.widthHeigt[0] + '%' + 'height:' + _vm.widthHeigt[1] + '%')},[_c('div',{staticClass:"video",attrs:{"id":"tcplayer"}})])}
var staticRenderFns = []

export { render, staticRenderFns }